import React from 'react';
import { useSelector, RootStateOrAny } from 'react-redux';
import { NewSession } from '~/components/ActiveCall/types';
import { IconAnnouncementActive as IconAnnouncement } from '~/assets/svgIcons';
import { ReactSVG } from './styles';

// FIXME: Clean up unsed announcement icons and rename IconAnnouncementActive to IconAnnouncement

type AnnouncementsButtonProps = {
  onClick: (session: NewSession) => void;
  session: NewSession;
};

const Announcements = ({ onClick, session }: AnnouncementsButtonProps) => {
  const {
    answered,
    callActions: { announcement: isAnnouncementOpened },
  } = session;

  const announcements = useSelector(
    (state: RootStateOrAny) => state.phone.announcements
  );

  const hasAnnouncements = Object.keys(announcements).length > 0;

  function clickHandler(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    onClick(session);
  }

  return (
    <>
      {answered && hasAnnouncements && (
        <button
          type="button"
          title="Play Announcements"
          disabled={!answered}
          onClick={clickHandler}>
          <ReactSVG selected={isAnnouncementOpened} src={IconAnnouncement} />
        </button>
      )}
    </>
  );
};

export default Announcements;
